export default {"src":"/_next/static/media/lumi-sparkle.edf0b344.svg","height":24,"width":25};